/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SIGN_IN_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.trag.signIn.user.getSignInType',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_SIGN_IN_TYPE' },
      },
    },
    GET_SIGN_IN_TYPE: {
      invoke: {
        id: 'getSignInType',
        src: 'getSignInType',
        onDone: {
          target: 'GET_SIGN_IN_TYPE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'GET_SIGN_IN_TYPE_FAILURE',
          actions: ['failureAction'],
        },
      },
    },
    GET_SIGN_IN_TYPE_SUCCESS: {
      type: 'final',
    },
    GET_SIGN_IN_TYPE_FAILURE: {
      on: {
        START: { target: 'GET_SIGN_IN_TYPE' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
